import { Navigate } from 'react-router-dom';
import { lazy } from 'src/utils/lazyComp';
import adminRouters from './adminRouters';
import cRouters from './cRouters';
import { IRouteProps } from './types';

const routes: IRouteProps[] = [
  {
    path: `admin`,
    title: '',
    element: lazy(() => import('src/components/layout/admin/AdminLayout')),
    children: adminRouters,
  },
  {
    path: `c`,
    title: '',
    element: lazy(() => import('src/components/layout/admin/AdminLayout')),
    children: cRouters,
  },
  {
    title: '登录',
    path: `login`,
    index: true,
    breadcrumb: false,
    element: lazy(() => import('src/containers/login')),
  },
  //内部专用的登录页面
  {
    title: '登录',
    path: `internalLogin`,
    index: true,
    breadcrumb: false,
    element: lazy(() => import('src/containers/internalLogin')),
  },
  {
    path: '403',
    element: lazy(() => import('src/components/NotFound/NoAccess')),
  },
  {
    path: '*',
    element: () => <Navigate to={`/login`} />,
  },
];

export default routes;
